import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducers/rootReducer';

// Persist config setup
const persistConfig = {
  key: 'root',
  storage,
};

// Apply persistReducer to root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store with middleware config
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: true, // Ensures async thunks are enabled
    }),
});

// Create persistor to persist store data
export type AppDispatch = typeof store.dispatch; // Type for dispatch
export type RootState = ReturnType<typeof store.getState>; // Type for state
persistStore(store);

export default store;
